export default "__VITE_ASSET__CV3_b3RN__"